import { NgModule } from "@angular/core";
import { Routes, RouterModule} from "@angular/router";
import { AuthGuard } from "./auth.guard";
import { LoginGuard } from "./login.guard";
import {LoadPageResolve} from "./loadPageResolve";
import { ChangePasswordComponent } from "./public/change-password";
import { LoginComponent } from "./public";
import { SidebarComponent } from "./sidebar";
import { UserGuard } from "./user.guard";
import { ProfileComponent } from "./profile";
import { UsersProfileComponent } from "./users-profile";
import { AllUsersComponent} from "./admin/all-users";
import { CreateUserComponent } from "./admin/create-user";
import { CreateAdminComponent } from "./superadmin/create-admin";
import { CryptoBalancesComponent } from "./crypto-balances/crypto-balances.component";
import {TransactionsComponent} from "./transactions/transactions.component";
import { WithdrawComponent } from "./withdraw/withdraw.component";
import { SessionsComponent } from "./sessions/sessions.component";
import { BinanceComponent } from "./binance/binance.component";
import { ExchangeComponent } from "@bt/exchange/exchange.component";
import { AutoCoinPurchaseComponent } from "@bt/auto-coin-purchase/auto-coin-purchase.component";
import { JobParametersModalComponent } from "@bt/auto-coin-purchase/job-parameters/job-parameters-component";

export const routes: Routes = [
    { path: "", redirectTo: "/login", pathMatch: "full" },
    {
        path: "login",
        component: LoginComponent,
        canActivate: [LoginGuard]
    },
    {
        path: "change-password",
        component: ChangePasswordComponent
    },
    {
        path: "",
        component: SidebarComponent,
        resolve:[LoadPageResolve],
        children: [
            {
                path: "all-users",
                component: AllUsersComponent,
                data: { roles: '1,2' },
                canActivate: [UserGuard]
            },
            {
                path: "create-user",
                component: CreateUserComponent,
                data: { roles: '1,2' },
                canActivate: [UserGuard]
            },
            {
                path: "create-admin",
                component: CreateAdminComponent,
                data: { roles: '1,2' },
                canActivate: [UserGuard]
            },
            {
                path: "users-profile/:id",
                component: UsersProfileComponent,
                data: { roles: '1,2' },
                canActivate: [UserGuard]
            },
            {
                path: "balances",
                component: CryptoBalancesComponent,
                data: { roles: '0,1,2' },
                canActivate: [UserGuard]
            },
            {
                path: "transactions",
                component: TransactionsComponent,
                data: { roles: '0,1,2' },
                canActivate: [UserGuard]
            },
            {
                path: "withdraw",
                component: WithdrawComponent,
                data: { roles: '0,1,2' },
                canActivate: [UserGuard]
            },
            {
                path: "sessions",
                component: SessionsComponent,
                data: { roles: '0,1,2' },
                canActivate: [UserGuard]
            },
            {
                path: "binance",
                component: BinanceComponent,
                data: { roles: '0,1,2' },
                canActivate: [UserGuard]
            },
            {
              path: "exchange",
              component: ExchangeComponent,
              data: { roles: '0,1,2' },
              canActivate: [UserGuard]
            },
            {
              path: "auto-coin-purchase-parameters",
              component: JobParametersModalComponent,
              data: { roles: '2' },
              canActivate: [UserGuard]
            },
            {
              path: "auto-coin-purchase",
              component: AutoCoinPurchaseComponent,
              data: { roles: '2' },
              canActivate: [UserGuard]
            }

        ],
        canActivate: [AuthGuard]
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts